import { render, staticRenderFns } from "./carousel-preview.component.vue?vue&type=template&id=6ed9b07c&scoped=true"
import script from "./carousel-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./carousel-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./carousel-preview.component.scss?vue&type=style&index=0&id=6ed9b07c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed9b07c",
  null
  
)

export default component.exports